import { createRoot } from "react-dom/client"
import "core-js/stable"
import "regenerator-runtime/runtime"
import { isEmpty, includes, chain, get } from "lodash"

import configureApp from "./configureApp"
import { loadLocalStore } from "./actions/localStore"
import init from "./init"
import "particles.js"

import Root from "./root"

// MUI X pings telemetry on mount; CSP blocks it anyway — opt out before render.
globalThis.__MUI_X_TELEMETRY_DISABLED__ = true

const app = document.getElementById("app")
const bundle = JSON.parse(app.getAttribute("data-bundle"))
const { segmentKey, captchaSiteKey, sentryUrl, ...initialStoreState } = bundle

init(sentryUrl, segmentKey, captchaSiteKey, bundle.user)

const loggedIn = !isEmpty(bundle.user)

delete initialStoreState.modelId
delete initialStoreState.snapshot
delete initialStoreState.mixpanelToken

const { store, router } = configureApp(initialStoreState)

const params = chain(window.location.search)
  .replace("?", "")
  .split("&")
  .map(param => param.split("="))
  .reduce((values, [key, value]) => {
    values[key] = value
    return values
  }, {})
  .value()

const isRefreshSession = get(params, "refreshSession")

if (window.opener && isRefreshSession) {
  const errorCode = get(params, "errorCode", "")

  window.localStorage.setItem("ompnt-refresh", errorCode)
  router.navigate("/refresh-login", { replace: true })
  window.close()
}

const requestedPage = chain(window.location.pathname)
  .split("/")
  .get("1")
  .value()

const isRoot = isEmpty(requestedPage)

if (loggedIn) {
  if (bundle.user.forceLinkAccount && requestedPage !== "link-account") {
    router.navigate("/link-account", { replace: true })
  }

  if (requestedPage === "activate-account") {
    router.navigate("/", { replace: true })
  }
} else if (!isRoot && !includes(["reset-password", "forgot-password", "activate-account"], requestedPage)) {
  const { search, pathname } = window.location
  let query = `/?redirect=${pathname}`
  if (search) {
    query += `&redirectSearch=${encodeURIComponent(search.substring(1))}`
  }

  router.navigate(query, { replace: true })
}

store.dispatch(loadLocalStore())

createRoot(app).render(<Root store={store} router={router} />)
